module.exports = "<label>\r\n    <dashboard-checkbox-toggle (click)=\"onClick()\"></dashboard-checkbox-toggle>\r\n</label>"